import api from './api';

/**
 * refertiProdottiApi.js — i referti SCRITTI dai medici.
 *
 * Diversi da quelli RICEVUTI, che stanno sotto /referti: il perché sta
 * nella migration 170. Due client separati perché sono due entità
 * separate, e un client solo farebbe sembrare che siano la stessa cosa.
 */
export const refertiProdottiAPI = {
    elenco: (pazienteId, stato, altri) =>
        api.get('/referti-prodotti', { params: { paziente_id: pazienteId, stato, ...(altri || {}) } }),
    dettaglio: (id) => api.get(`/referti-prodotti/${id}`),

    crea: (dati) => api.post('/referti-prodotti', dati),
    /* Dalla scheda compilata: i valori si COPIANO. Una correzione fatta
       dopo sulla scheda non cambierà questo referto, ed è il punto. */
    daCompilazione: (compilazioneId, dati) =>
        api.post(`/referti-prodotti/da-compilazione/${compilazioneId}`, dati || {}),
    /* Dalla procedura: i valori delle schede in tabella, i campi liberi
       nel corpo come prosa. Copiati anche questi. */
    daVisita: (visitaId, dati) =>
        api.post(`/referti-prodotti/da-visita/${visitaId}`, dati || {}),

    salva: (id, dati) => api.put(`/referti-prodotti/${id}`, dati),
    /* conferma_incompleto: dopo il 409 che elenca i dati mancanti. */
    concludi: (id, motivo, confermaIncompleto = false) =>
        api.post(`/referti-prodotti/${id}/concludi`, { motivo, conferma_incompleto: confermaIncompleto }),
    /* `dichiarazione` serve solo quando la versione precedente era
       uscita dalla clinica: il server risponde 400 con codice
       `serve_dichiarazione` e la schermata la chiede allora, invece di
       chiederla sempre. */
    correggi: (id, motivo, dichiarazione) =>
        api.post(`/referti-prodotti/${id}/correggi`, { motivo, ...(dichiarazione || {}) }),

    /* Lo stato si chiede PRIMA di disegnare i tasti: un tasto che
       compare e poi risponde «non disponibile» insegna a non premerlo. */
    statoFirma: () => api.get('/referti-prodotti/firma/stato'),
    firma: (id) => api.post(`/referti-prodotti/${id}/firma`),
    statoFse: () => api.get('/referti-prodotti/fse/stato'),
    inviaFse: (id) => api.post(`/referti-prodotti/${id}/invia-fse`),
    elimina: (id) => api.delete(`/referti-prodotti/${id}`),

    // L'anteprima arriva come blob: non c'è un indirizzo pubblico da aprire
    pdf: (id, versione) =>
        api.get(`/referti-prodotti/${id}/pdf`, { params: { versione }, responseType: 'blob' }),
    token: (id, versione) =>
        api.get(`/referti-prodotti/${id}/token`, { params: { versione } }),
};

export default refertiProdottiAPI;
